import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { api, formatApiErrorDetail } from "../lib/api";
import { Logo } from "../components/Logo";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password reset. Please sign in.");
      navigate("/login");
    } catch (err) { setError(formatApiErrorDetail(err.response?.data?.detail)); }
  };

  return (
    <div className="min-h-screen bg-brand-ceruleanDark flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-6"><Link to="/"><Logo light className="justify-center" /></Link></div>
        <div className="bg-white rounded-2xl shadow-2xl p-8">
          <h1 className="font-serif text-2xl text-brand-navy">Set a new password</h1>
          <p className="text-sm text-brand-slate mt-1 mb-6">Choose a strong password for your owner account.</p>
          <form onSubmit={submit} className="space-y-4">
            <div><Label>New password</Label><Input data-testid="reset-password-input" type="password" value={password} onChange={(e)=>setPassword(e.target.value)} className="mt-1" required minLength={8} /></div>
            {error && <p className="text-sm text-brand-coral">{error}</p>}
            <Button data-testid="reset-submit-btn" type="submit" className="w-full bg-brand-cerulean text-white rounded-full">Reset Password</Button>
          </form>
          <div className="mt-4 text-center"><Link to="/login" className="text-sm text-brand-cerulean hover:underline">← Back to sign in</Link></div>
        </div>
      </div>
    </div>
  );
}
